export default __webpack_public_path__ + "static/media/s_gts6.d29219de.jpg";